// @ts-nocheck
import { httpClient } from '../../../core/network';

class PartnerService {
  static fetchPartners() {
    const apiUrl = '/partners';
    return httpClient.get(apiUrl, {
      params: { segments: 'PARTNERS' },
    });
  }

  static createSubscription(email, productId) {
    const productData = {
      email: email,
      subscription: {
        productId: productId,
      },
    };

    const apiUrl = `/partners/subscribers`;
    return httpClient.post(apiUrl, productData);
  }

  static closeSubscription(vasToken) {
    const apiUrl = `/partners/subscribers/${vasToken}`;
    return httpClient.delete(apiUrl);
  }
}

export default PartnerService;
